import '@fortawesome/fontawesome-free/css/all.css';
import { createApp } from 'vue';
import App from '@/App.vue';
import vuetify from '@/plugins/vuetify';
import i18n from '@/i18n';
import router from '@/router';
import store from '@/store/index';
import Box21Api from '@/api/box21_api';
import { setBox21Api } from '@/util/apiHolder';
import * as Sentry from '@sentry/vue';

const app = createApp(App);

app.use(store);
app.use(router);
app.use(i18n);
app.use(vuetify);

const apiHost = '/api';
const box21Api = new Box21Api(app, apiHost, { store, router });
setBox21Api(box21Api);
store.$api = box21Api;
store._vm = { $api: box21Api };
app.config.globalProperties.$api = box21Api;
app.config.globalProperties.$api_url = `${apiHost}/static`;
app.config.globalProperties.$api_host = apiHost;

if (!document.URL.includes('localhost') && !document.URL.includes('test')) {
  Sentry.init({
    app,
    dsn: 'https://d67be3dad0fb84ba3b1f06b01891e54a@o90617.ingest.sentry.io/4506043867856896',
  });
}

router.isReady().then(() => {
  app.mount('#app');
});
